var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile-block",on:{"click":function($event){return _vm.openProfile()}}},[_c('div',{staticClass:"profile-block__name",domProps:{"innerHTML":_vm._s(_vm.userName)}}),_c('div',{staticClass:"profile-block__icon"},[_c('icon',{attrs:{"name":"user"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }